import { RadioContext } from "../__chunks/6I2PARRP.js";
import { useComposite } from "../__chunks/AAVDGJD5.js";
import "../__chunks/OXPV2NBK.js";
import "../__chunks/WJ37OVG2.js";
import "../__chunks/MYID4V27.js";
import "../__chunks/BMLNRUFQ.js";
import { createComponent, createElement, createHook } from "../__chunks/NQJBHION.js";
import { useWrapElement } from "../__chunks/J7Q2EO23.js";
import "../__chunks/CP3U4HPL.js";
import { __objRest, __spreadValues } from "../__chunks/PNRLI7OV.js";

// src/radio/radio-group.tsx
import { jsx } from "react/jsx-runtime";
var useRadioGroup = createHook(_a => {
  var _b = _a,
    {
      store
    } = _b,
    props = __objRest(_b, ["store"]);
  props = useWrapElement(props, element => /* @__PURE__ */jsx(RadioContext.Provider, {
    value: store,
    children: element
  }), [store]);
  props = __spreadValues({
    role: "radiogroup"
  }, props);
  props = useComposite(__spreadValues({
    store
  }, props));
  return props;
});
var RadioGroup = createComponent(props => {
  const htmlProps = useRadioGroup(props);
  return createElement("div", htmlProps);
});
if (process.env.NODE_ENV !== "production") {
  RadioGroup.displayName = "RadioGroup";
}
export { RadioGroup, useRadioGroup };